const normalizeMiddlewareUrl = (value) => {
  const url = String(value || '').trim().replace(/\/+$/, '');
  if (!url) return '';

  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href.replace(/\/+$/, '') : '';
  } catch (error) {
    return '';
  }
};

export const getConfiguredMiddlewareUrls = () => {
  if (typeof window === 'undefined' || !window.EZ_CONFIG) return [];

  const configured = window.EZ_CONFIG.API_MIDDLEWARE_URL;
  const values = Array.isArray(configured) ? configured : [configured];

  return [...new Set(values.map(normalizeMiddlewareUrl).filter(Boolean))];
};

export const getSelectedMiddlewareUrl = () => {
  if (typeof window === 'undefined' || !window.EZ_CONFIG) return '';

  const activeUrl = normalizeMiddlewareUrl(window.EZ_CONFIG.API_MIDDLEWARE_ACTIVE_URL);
  return activeUrl || getConfiguredMiddlewareUrls()[0] || '';
};

const probeMiddlewareUrl = async (baseUrl, timeout, checkPath) => {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeout);

  try {
    const normalizedPath = String(checkPath || '/').trim() || '/';
    const probeUrl = new URL(
      normalizedPath.startsWith('/') ? normalizedPath.slice(1) : normalizedPath,
      `${baseUrl}/`
    );

    const response = await fetch(probeUrl.href, {
      method: 'GET',
      mode: 'no-cors',
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });

    if (response.type !== 'opaque' && response.status >= 500) {
      throw new Error(`HTTP ${response.status}`);
    }

    return baseUrl;
  } finally {
    window.clearTimeout(timer);
  }
};

export const initializeMiddlewareUrl = async () => {
  if (
    typeof window === 'undefined' ||
    !window.EZ_CONFIG ||
    window.EZ_CONFIG.API_MIDDLEWARE_ENABLED !== true
  ) {
    return '';
  }

  const urls = getConfiguredMiddlewareUrls();
  if (!urls.length) return '';

  if (urls.length === 1) {
    window.EZ_CONFIG.API_MIDDLEWARE_ACTIVE_URL = urls[0];
    return urls[0];
  }

  const timeout = Math.max(
    500,
    Number(window.EZ_CONFIG.API_MIDDLEWARE_CHECK_TIMEOUT) || 3500
  );
  const checkPath = window.EZ_CONFIG.API_MIDDLEWARE_CHECK_PATH || '/';

  const selectedUrl = await new Promise((resolve) => {
    let failedCount = 0;
    let resolved = false;

    urls.forEach((url) => {
      probeMiddlewareUrl(url, timeout, checkPath)
        .then((availableUrl) => {
          if (resolved) return;
          resolved = true;
          resolve(availableUrl);
        })
        .catch(() => {
          failedCount += 1;
          if (!resolved && failedCount === urls.length) resolve('');
        });
    });
  });

  const activeUrl = selectedUrl || urls[0];
  window.EZ_CONFIG.API_MIDDLEWARE_ACTIVE_URL = activeUrl;
  return activeUrl;
};
